import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { CloudDownloadOutlined } from '@mui/icons-material'

export const Root = styled('div')`
  background: ${props => props.theme.palette.brand.gray3};
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const DowloadIcon = styled(CloudDownloadOutlined)``

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    text-align: ${props => props.textAlign};
  }
`

export const Link = styled(LinkBase)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const TextDownload = styled('span')`
  letter-spacing: 1.15px;
  margin-left: 16px;
`
